import { create } from "zustand";

interface LoaderStore {
    status: boolean;        // true = loading, false = not loading
    loaderTitle: string;    // optional title for the loader

    // actions
    showLoader: (title?: string) => void;
    hideLoader: () => void;
}

export const useLoaderStore = create<LoaderStore>((set) => ({
    status: false,
    loaderTitle: '',

    showLoader: (title = '') => set({ status: true, loaderTitle: title }),
    hideLoader: () => set({ status: false, loaderTitle: '' })
}));
